export const environment = {
  appName: 'DBKK TAMS Roadrunner',
  production: true,
  apiUrl: 'https://tams.dbkk.staging.digiheritage.com.my/roadrunner-backend/api/v1',
  mediaHubUrl: 'https://tams.dbkk.staging.digiheritage.com.my/media-hub/images',
  /** Same-origin Coyote path (staging baseHref /map/). Avoids X-Frame-Options / CSP frame-ancestors blocks. */
  mapViewerUrl: '/map',
};
